/* TreatmentTable.ts */

export enum TreatmentLabels {
  TIMELINE = "Timeline",
  OTHER = "Other",

  // Treatments
  ARA_C = "ARA-C",
  CYCLOPHOSPHAMIDE_MONOTHERAPY = "Cyclophosphamide monotherapy",
  NOT_REACHED = "Not reached",
  ONGOING = "Ongoing",
  R_BENDA = "R-Benda",
  R_CHOP = "R-CHOP",
  R_MINI_CHOP = "R-miniCHOP",
  R_MTX = "R-MTX",
  R_POLA_CHP = "R-POLA CHP",
  VENETOCLAX_MONOTHERAPY = "Venetoclax monotherapy",
  ACALABRUTINIB_MONOTHERAPY = "Acalabrutinib monotherapy",
  BENDAMUSTINE_AND_OBINUTUZUMAB = "Bendamustine and Obinutuzumab",
  BENDAMUSTINE_MONOTHERAPY = "Bendamustine monotherapy",
  CHLORAMBULIC_AND_OBINUTUZMAB = "Chlorambucil and Obinutuzumab (GClb)",
  CHLORAMBULIC_MONOTHERAPY = "Chlorambucil monotherapy",
  DECEASED = "Deceased",
  WATCH_AND_WAIT = "Watch and Wait",
  FCR = "FCR",
  FLUDARABINE_AND_RITUXIMAB = "Fludarabine and Rituximab (FR)",
  IBRUTINIB_AND_VENETOCLAX = "Ibrutinib and Venetoclax",
  IBRUTINIB_MONOTHERAPY = "Ibrutinib monotherapy",
  IDELALISIB_AND_RITUXIMAB = "Idelalisib and Rituximab",
  IDELAISIB_MONOTHERAPY = "Idelalisib monotherapy",
  OBINUTUZUMAB_MONOTHERAPY = "Obinutuzumab monotherapy",
  RITUXIMAB_MONOTHERAPY = "Rituximab monotherapy",
  VENETOCLAX_AND_OBINUTUZUMAB = "Venetoclax and Obinutuzumab",
  ZANUBRUTINIB_MONOTHERAPY = "Zanubrutinib monotherapy",

  // Medications
  BORTEZOMIB = "Bortezomib",
  ADALIMUMAB = "Adalimumab",
  AZATHIOPRINE = "Azathioprine",
  BUDESONIDE = "Budesonide",
  CORTISONE = "Cortisone",
  GOLIMUMAB = "Golimumab",
  INFLIXIMAB = "Infliximab",
  MESALAMINE = "Mesalamine",
  PREDNISOLONE = "Prednisolone",
  USTEKINUMAB = "Ustekinumab",
  VEDOLIZUMAB = "Vedolizumab",
}
